export class SectionQuickBuyCategories extends window.BAO.CustomElement() {
  static get styles () {
    return `
      :host {
        display: block;
      }
    `
  }

  static get requiredElements () {
    return ['media']
  }

  setupListeners () {
    super.setupListeners()

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.ACCORDION.TAB_CHANGED,
      this.onTabChanged.bind(this),
    )
  }

  checkValidity () {
    super.checkValidity()

    this.els.media.elements.forEach(element => {
      if (!('index' in element.dataset)) {
        this.throwError(
          `[data-index] is required on all [data-section-quick-buy-categories-el="media"] elements`,
        )
      }

      if (!('shouldSwapTo' in element.dataset)) {
        this.throwError(
          `[data-should-swap-to] is required on all [data-section-quick-buy-categories-el="media"] elements`,
        )
      }
    })
  }

  onTabChanged (event) {
    const { index } = event.detail
    const mediaElement = this.els.media.elements[index]
    if (mediaElement.dataset.shouldSwapTo === 'false') return

    this.els.media.elements.forEach((element, i) => {
      element.setAttribute('aria-hidden', (i !== index).toString())
    })
  }
}

if (!customElements.get('section-quick-buy-categories')) {
  customElements.define(
    'section-quick-buy-categories',
    SectionQuickBuyCategories,
  )
}
